var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button"
  }, [_vm.id ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.invite-modal",
      modifiers: {
        "invite-modal": true
      }
    }],
    class: _vm.buttonClass,
    attrs: {
      "text": _vm.text,
      "variant": _vm.variant,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        _vm.inviteSection = true;
      }
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require(`@/assets/${_vm.icon}`)
    }
  }), _vm._v(" " + _vm._s(_vm.$t('invite.invite')) + " ")]) : _vm._e(), _c('custom-modal', {
    staticClass: "customer-project-invite-modal",
    attrs: {
      "id": "invite-modal",
      "icon": "customer-project/danger.svg",
      "size": "lg"
    },
    on: {
      "close": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.inviteSection,
            expression: "inviteSection"
          }]
        }, [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.failed,
            expression: "!failed"
          }],
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/invite-icon.svg")
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.failed,
            expression: "failed"
          }],
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.invite.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.invite.body')) + " ")]), _c('div', {
          staticClass: "form-container"
        }, [_c('invite-form', {
          attrs: {
            "id": _vm.id,
            "error": _vm.inviteError,
            "loading": _vm.loading,
            "events": _vm.events
          },
          on: {
            "submit": _vm.onSubmit,
            "cancel": function ($event) {
              return _vm.$bvModal.hide('invite-modal');
            },
            "fail": function ($event) {
              _vm.failed = true;
            }
          }
        })], 1)]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.inviteSection,
            expression: "!inviteSection"
          }]
        }, [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/invite-successful.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.invite-successful.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.invite-successful.body')) + " "), _c('br'), _c('strong', [_vm._v(" " + _vm._s(_vm.inputEmail) + " ")])]), _c('div', {
          staticClass: "form-container"
        }, [_c('b-button', {
          staticClass: "w-100 modal-button-back",
          on: {
            "click": function ($event) {
              return _vm.$bvModal.hide('invite-modal');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('back')) + " ")])], 1)])];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }